import { BorderStyleSelectorStoryblok } from '../types/bloks/borderStyleSelector';

export function getBorderStyleFromStory(story: BorderStyleSelectorStoryblok[]) {
  return story?.[0]?.borderStyle?.content?.value;
}
